module.exports = __webpack_public_path__ + "static/16_norsk-a1de13903dffb776f83e327aed89244c.png";